import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme)=> {
    return {
            container: {
                position: 'fixed',
                height: '100%',
                width: '100%',
                zIndex: 1400,
                opacity: 1,
                // transition: 'opacity 0.2s ease-in'
            },
            footer: {
                position: "fixed",
                width: '100%',
                bottom: 0,
                left: 0,
                textAlign: "center",
                padding: theme.spacing(1),
                display: 'flex',
                justifyContent: "center",
                alignItems: "center"
            }
        }
})